import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appThousandSeparator]'
})
export class ThousandSeparatorDirective {

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: any): void {
    const input = event.target as HTMLInputElement;
    const originalValue = input.value;

    // Eliminar todos los caracteres no numéricos y puntos de separación de miles
    let value = originalValue.replace(/[^\d]/g, '');

    // Formatear con puntos como separadores de miles
    const parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    value = parts.join('.');

    // Si el valor cambió, actualizar el campo de entrada
    if (value !== originalValue) {
      input.value = value;
    }
  }
}
